import { IUniform } from "../types";

/**
 * Makes it easier to type out and get better editor help in establishing initShader
 */
export function createUniform(options: IUniform) {
  return options;
}
